import Vue from 'vue';
import Vuex from 'vuex';

import common from './modules/common';
import user from "./modules/user";
import memorandum_create from "./modules/memorandum/memorandum_create";
import users_filter from "./modules/users_filter";
import inbox_store from "./modules/inbox_state/data";
import mem_count from "./modules/memorandum/mem_count";
import memorandum_inside from "./modules/memorandum/memorandum_inside";
import memorandum_work_tabs from "./modules/memorandum/memorandum_work_tabs";
import uprox_status from "./modules/uprox/uprox_status";


Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		common,
		mem_count,
		user,
		memorandum_create,
		memorandum_inside,
		users_filter,
		inbox_state : inbox_store,
		memorandum_work_tabs,
		uprox_status,
	},
})
